import {
  Select as BaseSelect,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ComponentPropsWithoutRef, ReactNode } from "react";
import { cn } from "@/lib/utils";

export type SelectOption<T = any> = {
  value: T;
  label: ReactNode;
  description?: ReactNode;
};
export type SelectProps<T extends string = string> = {
  options: SelectOption[];
  value: T;
  onChange: (value: T) => void;
  placeholder?: string;
  autoFocus?: boolean;
  triggerProps?: ComponentPropsWithoutRef<typeof SelectTrigger>;
  clearable?: boolean;
  onClear?: () => void;
};

export function Select<T extends string>({
  value,
  options,
  onChange,
  placeholder = "Select...",
  autoFocus = false,
  triggerProps,
}: SelectProps<T>) {
  return (
    <BaseSelect onValueChange={onChange} value={value} defaultOpen={autoFocus}>
      <SelectTrigger
        {...triggerProps}
        className={cn("w-full truncate", triggerProps?.className)}
      >
        <SelectValue placeholder={placeholder} className="w-full" />
      </SelectTrigger>
      <SelectContent className="max-h-40 overflow-y-auto">
        {options.map((item) => (
          <SelectItem value={item.value} key={item.value}>
            {item.label}
          </SelectItem>
        ))}
      </SelectContent>
    </BaseSelect>
  );
}
